import React from 'react';
import { Pressable, Text, StyleSheet } from 'react-native';

const PeriodoChip = ({ active, onPress, children, style }) => (
  <Pressable
    onPress={onPress}
    style={({ pressed }) => [
      styles.chip,
      active && styles.chipActive,
      pressed && styles.chipPressed,
      style,
    ]}
  >
    <Text style={[styles.text, active && styles.textActive]}>{children}</Text>
  </Pressable>
);

const styles = StyleSheet.create({
  chip: {
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 16,
    backgroundColor: '#f0f0f0',
    borderWidth: 1,
    borderColor: '#e0e0e0',
    marginRight: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  chipActive: {
    backgroundColor: '#4CAF50',
    borderColor: '#4CAF50',
  },
  chipPressed: {
    opacity: 0.7,
  },
  text: {
    color: '#333',
    fontSize: 14,
    fontWeight: '500',
  },
  textActive: {
    color: '#fff',
    fontWeight: '600',
  },
});

export default PeriodoChip;
